// extracted by mini-css-extract-plugin
module.exports = {"secondScreen":"SecondScreen_secondScreen__xzw68"};